import { jsx, Fragment } from 'react/jsx-runtime';
import { ClerkProvider } from '@clerk/clerk-react';
import { dark } from '@clerk/themes';
import { useState, useEffect } from 'react';
import { useTheme } from './ThemeContext.js';

function ClerkThemeWrapper({ publishableKey, satellite, children }) {
    const { theme } = useTheme();
    const [actualTheme, setActualTheme] = useState('light');
    // Update actual theme based on current theme setting
    useEffect(() => {
        const updateActualTheme = () => {
            if (theme === 'system') {
                setActualTheme(window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
            }
            else {
                setActualTheme(theme);
            }
        };
        updateActualTheme();
        // Listen for system theme changes when using system theme
        if (theme === 'system') {
            const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
            mediaQuery.addEventListener('change', updateActualTheme);
            return () => mediaQuery.removeEventListener('change', updateActualTheme);
        }
    }, [theme]);
    if (!publishableKey) {
        return jsx(Fragment, { children: children });
    }
    const appearance = {
        baseTheme: actualTheme === 'dark' ? dark : undefined,
    };
    // Clerk's provider props are a discriminated union on `isSatellite`, so the
    // two modes are rendered as separate elements rather than a conditional
    // prop spread.
    if (satellite) {
        return (jsx(ClerkProvider, { publishableKey: publishableKey, isSatellite: true, domain: satellite.domain, signInUrl: satellite.signInUrl, signUpUrl: satellite.signUpUrl, 
            // Fallback, not force: Clerk still honours an explicit
            // `redirect_url` when a user was deep-linked into a page before
            // signing in. This only supplies the destination when nothing else
            // does — which is exactly the case that was sending satellite
            // users to the primary product.
            signInFallbackRedirectUrl: satellite.afterSignInUrl, signUpFallbackRedirectUrl: satellite.afterSignUpUrl, appearance: appearance, children: children }));
    }
    return (jsx(ClerkProvider, { publishableKey: publishableKey, appearance: appearance, children: children }));
}

export { ClerkThemeWrapper };
//# sourceMappingURL=ClerkThemeWrapper.js.map
